import React from 'react';
import { Link } from 'react-router-dom';
import { useOrgStore } from '../../store/org';
import { orgRoleLabel } from '../../auth/capabilities';
import { VpState } from '../../components/VelopulseShell';
import useLoad from '../../utils/useLoad';
import { vpApi, errorMessage } from '../../api/velopulse';

export default function OrgAdminOverviewPage() {
  const currentOrg = useOrgStore((s) => s.currentOrg);
  const orgId = currentOrg?.id;
  const { data, error, loading, reload } = useLoad(
    () => (orgId ? vpApi.getOrgOverview() : Promise.resolve(null)),
    [orgId],
  );

  const counts = data?.counts || {};
  const labels = Array.isArray(data?.module_labels) ? data.module_labels : (currentOrg?.module_labels || []);
  const showSpinner = loading && !data && !error && !!orgId;

  return (
    <div className="vp-content" style={{ maxWidth: 760 }}>
      <div className="vp-hello">
        <div>
          <h1>公司管理</h1>
          <p>正在管理：{currentOrg?.name || '未選擇公司'}　你的身分：{orgRoleLabel(currentOrg)}</p>
        </div>
      </div>
      {!orgId ? (
        <div className="vp-warnbox">請先選擇公司後再查看摘要。下方入口仍可使用。</div>
      ) : showSpinner ? (
        <VpState loading />
      ) : (
        <>
          {error ? (
            <div className="vp-warnbox" role="alert">
              {errorMessage(error, '無法載入最新公司摘要。')}成員與公司設定仍可從下方進入。
              <div style={{ marginTop: 8 }}>
                <button type="button" className="vp-btn" onClick={reload}>重新載入摘要</button>
              </div>
            </div>
          ) : null}
          <div className="vp-kpi" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
            <div className="vp-box"><div className="l">啟用成員</div><div className="v">{counts.active ?? '—'}</div></div>
            <div className="vp-box"><div className="l">公司管理員</div><div className="v">{counts.admins ?? '—'}</div></div>
            <div className="vp-box"><div className="l">進行中邀請</div><div className="v">{counts.pending_invites ?? '—'}</div></div>
          </div>
          {data?.invites_error ? (
            <p className="vp-muted" style={{ marginTop: 8 }}>邀請清單暫時無法載入，不影響成員與公司資料。</p>
          ) : null}
          {labels.length > 0 && (
            <div className="vp-card" style={{ marginTop: 12 }}>
              <h2>已開通模組</h2>
              <div className="vp-module-badges">
                {labels.map((m) => <span key={m.key} className="vp-badge blue">{m.label}</span>)}
              </div>
              <p className="vp-muted" style={{ margin: '8px 0 0' }}>模組由平台開通，公司管理員只能查看。</p>
            </div>
          )}
        </>
      )}
      <div className="vp-card" style={{ marginTop: 12 }}>
        <h2>下一步</h2>
        <Link className="vp-item" to="/org-admin/members">
          <div>成員與角色<div className="vp-sub">邀請、改角色、撤銷邀請。停用只影響這家公司，不會停用對方在其他公司的帳號。</div></div>
        </Link>
        <Link className="vp-item" to="/org-admin/settings">
          <div>公司設定<div className="vp-sub">公司名稱與已開通模組。帳務尚未開放；模組由平台調整。</div></div>
        </Link>
      </div>
    </div>
  );
}
